import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { AiConsentBox } from "@/components/AiConsent";
import { DownloadSimple, Lock, Sparkle, WarningCircle, Eye } from "@phosphor-icons/react";

export function StudioActions({
  owned, keepsake, enough, min, selectedCount, hasPhotos, aiConsent, setAiConsent, onHow,
  photoConsent, setPhotoConsent, writing, building, onWrite, onBuy, onDownload, onRead,
}) {
  if (!owned) {
    return (
      <div data-testid="studio-buy-panel" className="mt-4 space-y-3 rounded-2xl border border-[#E07A5A]/30 bg-[#FBEDE6] p-4">
        <p className="text-sm text-[#4A4540]">
          <strong>Preview only.</strong> Try your selection, title and photos here. To have your book written and
          download it, unlock My Life Story Ebook — A$49.99 one-time, AUD. No GST applies.
        </p>
        <p className="text-xs text-[#8A5A2B]">
          Your memory selection, title and dedication are kept on this device. Photos are cleared when you leave this
          page — you'll pick them again after purchase.
        </p>
        <Button data-testid="studio-buy-btn" onClick={onBuy} className="w-full rounded-full bg-[#E07A5A] py-5 text-white hover:bg-[#d66b4b]">
          <Lock size={16} weight="fill" className="mr-2" /> Unlock my Ebook — A$49.99
        </Button>
      </div>
    );
  }

  if (!keepsake) {
    return (
      <div data-testid="studio-write-panel" className="mt-4 space-y-3">
        {!enough && (
          <p data-testid="studio-not-enough" className="text-sm text-[#8A5A2B]">
            Please select at least {min} memories (you have {selectedCount} selected) so your book has enough to tell.
          </p>
        )}
        <AiConsentBox k="life_story_ebook" checked={aiConsent} onChange={setAiConsent} onHow={onHow} />
        <Button
          data-testid="studio-write-btn"
          disabled={!enough || !aiConsent || writing}
          onClick={onWrite}
          className="w-full rounded-full bg-[#2E3B31] py-6 text-base text-[#FBF4E8] hover:bg-[#3d4d40]"
        >
          <Sparkle size={18} className="mr-2" /> {writing ? "Writing your book… this can take a minute" : "Write my book"}
        </Button>
        <p className="text-center text-[11px] text-[#8A7F76]">Only the text of your selected memories is sent to the AI. Your photos stay here.</p>
      </div>
    );
  }

  return (
    <div data-testid="studio-download-panel" className="mt-4 space-y-3">
      <div data-testid="pre-create-warning" className="rounded-xl border border-[#E0A458]/50 bg-[#FBF0DD] p-3 text-xs text-[#8A5A2B]">
        <WarningCircle size={15} weight="fill" className="mr-1 inline align-text-bottom" />
        Your photos stay on this device and are <strong>not saved to your account</strong>. Please download your
        completed Ebook <strong>before leaving this page</strong>. To make it again later (free), you'll choose your photos again.
      </div>
      {hasPhotos && (
        <label data-testid="photo-consent-box" className="flex cursor-pointer items-start gap-3 rounded-2xl border border-[#4A4540]/15 bg-white p-4">
          <Checkbox data-testid="photo-consent-checkbox" checked={photoConsent} onCheckedChange={(v) => setPhotoConsent(!!v)} className="mt-0.5" />
          <span className="text-sm text-[#4A4540]">
            I understand my photos will be placed into my Ebook PDF on my own device. I will download and keep the
            finished Ebook myself. My original photos will not be stored in my account or shared publicly.
          </span>
        </label>
      )}
      <Button
        data-testid="ebook-download-btn"
        disabled={building || (hasPhotos && !photoConsent)}
        onClick={onDownload}
        className="w-full rounded-full bg-[#E07A5A] py-6 text-base text-white hover:bg-[#d66b4b] disabled:opacity-50"
      >
        <DownloadSimple size={18} className="mr-2" /> {building ? "Creating on this device…" : "Create & download my Ebook"}
      </Button>
      <Button data-testid="studio-read-btn" variant="outline" onClick={onRead} className="w-full rounded-full border-[#4A4540]/20">
        <Eye size={16} className="mr-2" /> Read the text online
      </Button>
      <p className="text-center text-[11px] text-[#8A7F76]">PDF created on your device · nothing uploaded · rebuild anytime for free</p>
    </div>
  );
}
